import { request } from "./request";
import * as apiConstants from "../constants/Api";

export const fetchAccount = () => {
  return request("get", apiConstants.SERVER_URL + "/form-service/company");
};
